import { useEffect } from 'react';

type UseContentProtectionOptions = {
  warningMessage?: string;
  /**
   * Callback fired each time a print/export attempt is detected.
   */
  onTrigger?: () => void;
};

const DEFAULT_WARNING =
  'Printing, exporting, or redistributing this material is prohibited by English2Empower policy.';

export function useContentProtection({
  warningMessage = DEFAULT_WARNING,
  onTrigger,
}: UseContentProtectionOptions = {}) {
  useEffect(() => {
    const showWarning = () => {
      onTrigger?.();
      window.alert(warningMessage);
    };

    const handleKeydown = (event: KeyboardEvent) => {
      if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 'p') {
        event.preventDefault();
        showWarning();
      }
    };

    const handleBeforePrint = (event: Event) => {
      event.preventDefault?.();
      showWarning();
    };

    const handleAfterPrint = () => {
      showWarning();
    };

    document.addEventListener('keydown', handleKeydown);
    window.addEventListener('beforeprint', handleBeforePrint);
    window.addEventListener('afterprint', handleAfterPrint);

    return () => {
      document.removeEventListener('keydown', handleKeydown);
      window.removeEventListener('beforeprint', handleBeforePrint);
      window.removeEventListener('afterprint', handleAfterPrint);
    };
  }, [onTrigger, warningMessage]);
}


